import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AsmsService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getAsmsList() {
    return this.httpClient.get<any[]>(`${environment.provisionerUrl}/asms/asmslist`);
  }

  checkOperationsOwner(asms: string): Observable<boolean> {
    return this.httpClient.get<any>(`${environment.provisionerUrl}/asms/hasOperationsOwner/${asms}`).pipe(
      map(response => response?.result?.success === true),
      catchError(() => of(false)) // treat error as invalid ASMS
    );
  }
  
}
